<app-header></app-header>
@if (showBanner) {
  <app-merchandising></app-merchandising>
}
<app-nav></app-nav>

<aa-mobile-navigation></aa-mobile-navigation>

<div class="content-wrap clearfix">
  <div class="d-flex" [ngClass]="{'flex-column':this['appUtilityService'].isMobile}">
    <div class="w-100">
      <router-outlet></router-outlet>
    </div>
    @if (this['appUtilityService'].isDesktop || !isBetaFeatures) {
      <aa-app-advertisement class="sidebar_advertisement" type="the-aa-mpu"></aa-app-advertisement>
    } @else if (isBetaFeatures) {
      <aa-app-advertisement class="sidebar_advertisement" type="the-aa-middle-mobile"></aa-app-advertisement>
    }
  </div>
  <router-outlet name="modal"></router-outlet>
</div>

<div class="hide-mobile-only" [ngClass]="{'show-mobile-only': showOnMobileDirectionOnly}">
  <aa-app-advertisement type="the-aa-billboard" class="hide-mobile-only"></aa-app-advertisement>
  <app-about-section></app-about-section>
  <app-smart-care-section></app-smart-care-section>
  <app-car-models-section></app-car-models-section>
  <app-breadcrumbs></app-breadcrumbs>
  <app-footer></app-footer>
</div>

@if (openInterstitialAd()) {
<div class="modal-backdrop show"></div>
<div class="modal show" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content">

      <button class="rounded-circle bg-transparent close border-0" type="button" (click)="openInterstitialAd.set(false)"
        data-bs-dismiss="modal" aria-label="Close">
        <span></span>
      </button>

      <div class="modal-body">
        <aa-app-advertisement type="the-aa-interstitial" class="modal-ad"></aa-app-advertisement>
      </div>
    </div>
  </div>
</div>
}
